// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VYc8T","newExpiryDate":"styles_newExpiryDate__Q3R_q","footer":"styles_footer__1qusj"};